
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Cabserviceinsatara() {



const cardData = {
  keyword: 'Corporate Cab Services in Satara MIDC',
  heading: 'eTravo: Reliable Corporate Cab Services in Satara MIDC',
  headingDescription: `eTravo provides trusted corporate cab services in Satara MIDC, catering to businesses, manufacturing units, and industrial operations. Our services are designed for seamless employee transport, executive transfers, and business travel requirements. With a focus on punctuality, safety, and comfort, we operate a fleet of well-maintained, GPS-enabled AC cabs driven by courteous professionals. Whether it's regular shift commutes, client visits, or on-demand rides, eTravo ensures smooth and cost-effective travel solutions. We help businesses improve productivity by taking care of their transportation logistics with reliable and flexible rental plans.`,

  top: 'Key Industrial and Business Hubs Served by eTravo in Satara MIDC',
  topPlaces: [
    {
      title: 'Satara MIDC Industrial Area',
      description: `A major hub for manufacturing, automotive, and agro-based industries. eTravo serves this zone with timely employee pickup and drop solutions, customized for shift-based schedules and high-volume workforce transport.`
    },
    {
      title: 'Karad MIDC',
      description: `Located near Satara, this industrial area is known for engineering and processing units. eTravo offers inter-MIDC shuttle services and executive travel for management staff commuting between industrial sites.`
    },
    {
      title: 'Satara City Business District',
      description: `As the administrative and commercial center, we offer premium cab services for executives, client meetings, and event transport across key offices and government establishments.`
    },
    {
      title: 'Satara Railway Station',
      description: `Our point-to-point cab services from Satara Railway Station support staff arrivals and departures, enabling reliable last-mile connectivity for daily commuters and business visitors.`
    },
    {
      title: 'Logistics and Warehousing Clusters',
      description: `Serving transport hubs and logistic companies with efficient movement of staff, warehouse workers, and support teams, particularly in peak operation hours.`
    }
  ],

  services: [
    {
      name: 'Satara MIDC Corporate Cab Rentals',
      description: `We provide short and long-term corporate cab rentals tailored to industrial clients. With a focus on reliability and flexibility, our rental services help businesses streamline their transport needs for daily commutes, meetings, or event-based travel.`
    },
    {
      name: 'Employee Transport Cab Satara MIDC',
      description: `Our staff transportation services are designed around company shift timings and operational demands. From factory workers to office employees, our well-maintained cabs ensure safe, on-time commutes every day.`
    },
    {
      name: 'Business Cab Services Satara MIDC',
      description: `Professional cab solutions for internal business travel, vendor site visits, and intra-city meetings. eTravo offers prompt and courteous service to business owners and field teams.`
    },
    {
      name: 'Corporate Staff Cabs Satara MIDC',
      description: `We manage multi-stop staff routes with GPS monitoring, providing organizations with transparency, control, and the convenience of well-organized daily travel.`
    },
    {
      name: 'Reliable Corporate Cab Service Satara MIDC',
      description: `eTravo’s reputation for reliability is built on punctual services, responsive support, and trained drivers. Our clients trust us for consistent performance every day.`
    },
    {
      name: 'AC Corporate Cabs Satara MIDC',
      description: `Our air-conditioned cabs guarantee a comfortable commute, even during the extreme weather conditions in Satara, ensuring stress-free travel for staff and executives.`
    },
    {
      name: 'Staff Pickup and Drop Cab Satara MIDC',
      description: `We operate 24x7 staff transport services, ideal for factories and plants running round-the-clock operations. Each route is optimized for efficiency and reliability.`
    },
    {
      name: 'Affordable Business Cab Rentals Satara MIDC',
      description: `We offer cost-effective rental packages with flexible billing cycles, perfect for both SMEs and large companies seeking to minimize transport overhead without compromising quality.`
    },
    {
      name: 'Executive Cab Services Satara MIDC',
      description: `Luxury cab options for top management, featuring premium vehicles and chauffeurs who understand corporate etiquette, ideal for business travel and airport transfers.`
    },
    {
      name: 'Monthly Corporate Cab Rentals Satara MIDC',
      description: `Our monthly rental programs offer businesses predictable and manageable transport solutions with route planning, fixed scheduling, and reporting tools for monitoring.`
    },
    {
      name: 'Industrial Area Employee Transport Satara MIDC',
      description: `From the outskirts of Satara to core industrial locations, our transport network is designed to ensure complete coverage for employee mobility across zones.`
    },
    {
      name: 'Corporate Client Cabs Satara MIDC',
      description: `First impressions matter. Our cab services for visiting clients ensure punctuality, cleanliness, and comfort, helping you uphold a strong professional image.`
    },
    {
      name: 'Business Meeting Cabs Satara MIDC',
      description: `Need a ride at short notice for an urgent meeting? Our responsive cab services offer quick dispatch and reliable navigation for timely arrivals.`
    },
    {
      name: 'Satara Industrial Area Cab Hire',
      description: `On-demand cab hire options for ad-hoc travel, site inspections, or sudden team movements. We’re equipped to handle last-minute bookings efficiently.`
    },
    {
      name: 'Corporate Shuttle Cabs Satara MIDC',
      description: `Shuttle cab options for groups of employees, particularly useful for events, inter-department movements, and high-volume shift changes in manufacturing setups.`
    }
  ],

  tableData: [
    ['Satara MIDC Corporate Cab Rentals', 'Employee Transport Cab Satara MIDC'],
    ['Business Cab Services Satara MIDC', 'Corporate Staff Cabs Satara MIDC'],
    ['Reliable Corporate Cab Service Satara MIDC', 'AC Corporate Cabs Satara MIDC'],
    ['Staff Pickup and Drop Cab Satara MIDC', 'Affordable Business Cab Rentals Satara MIDC'],
    ['Executive Cab Services Satara MIDC', 'Monthly Corporate Cab Rentals Satara MIDC'],
    ['Industrial Area Employee Transport Satara MIDC', 'Corporate Client Cabs Satara MIDC'],
    ['Business Meeting Cabs Satara MIDC', 'Satara Industrial Area Cab Hire'],
    ['Corporate Shuttle Cabs Satara MIDC', '']
  ],


"whychoose": [
  {
    "WhyChooseheading": "Reliable Cab Services for Businesses in Satara MIDC",
    "WhyChoosedescription": "eTravo offers dedicated corporate cab solutions for Satara MIDC—an important industrial zone known for engineering, manufacturing, and agro-processing units. Our services are designed to ensure timely employee transportation, reduce shift delays, and support smoother day-to-day operations. We help businesses in Satara MIDC optimize workforce mobility while ensuring safety, comfort, and cost-efficiency across all transport needs."
  },
  {
    "WhyChooseheading": "Versatile Fleet to Support All Corporate Needs",
    "WhyChoosedescription": "We provide a wide selection of vehicles including sedans, MUVs, and SUVs, suitable for executive travel, group employee transport, and inter-office transfers. Each vehicle is air-conditioned, GPS-enabled, and regularly serviced for maximum comfort and performance."
  },
  {
    "WhyChooseheading": "Locally Experienced and Trained Drivers",
    "WhyChoosedescription": "Our drivers are experienced professionals familiar with Satara MIDC’s internal roads, traffic patterns, and industrial blocks. They are trained in corporate service standards and safe driving practices, ensuring a respectful and reliable commute experience for your employees."
  },
  {
    "WhyChooseheading": "Flexible Booking for Shift-Based Operations",
    "WhyChoosedescription": "We accommodate the diverse scheduling needs of factories and offices with customizable transport plans. Whether your business requires daily pickups, rotating shift coverage, or emergency on-demand rides, our flexible booking system ensures seamless coordination."
  },
  {
    "WhyChooseheading": "Real-Time GPS Monitoring and Trip Insights",
    "WhyChoosedescription": "All rides are monitored through GPS tracking to provide real-time updates to your HR or admin team. You can track vehicle location, ETA, and route history, increasing accountability and allowing for quick resolution of any delays or deviations."
  },
  {
    "WhyChooseheading": "Transparent Monthly Billing with Detailed Trip Logs",
    "WhyChoosedescription": "eTravo provides GST-compliant invoices with clear fare breakdowns and complete ride logs. Our billing system helps finance teams track transportation expenses, streamline approvals, and maintain accurate audit records."
  },
  {
    "WhyChooseheading": "Safety and Hygiene as Top Priorities",
    "WhyChoosedescription": "To ensure a secure travel experience, our vehicles undergo routine sanitization and follow strict hygiene standards. Drivers are health-screened and instructed to adhere to safety protocols for the well-being of all passengers."
  },
  {
    "WhyChooseheading": "Dedicated Account Management for Corporates",
    "WhyChoosedescription": "Each client is assigned a dedicated account manager who ensures smooth onboarding, manages transport operations, resolves queries quickly, and tailors service as your business evolves. This helps maintain a consistent and professional experience."
  }
]
}

const faqData = [
  [
    {
      question: "Do your services cover all areas of Satara MIDC?",
      answer: "Yes, we provide comprehensive coverage of Satara MIDC and nearby industrial zones, ensuring timely pickups and drop-offs for your entire team."
    },
    {
      question: "Can we book recurring rides for employee shifts?",
      answer: "Absolutely. We support recurring ride scheduling based on fixed or flexible shift patterns for maximum convenience and efficiency."
    },
    {
      question: "Is monthly consolidated billing available?",
      answer: "Yes, we provide consolidated monthly invoices with itemized trip data to simplify accounting and budgeting processes."
    },
    {
      question: "Are drivers trained for industrial zone navigation and protocols?",
      answer: "Yes, our drivers are well-versed in industrial traffic, gate protocols, and safety compliance, offering smooth access across MIDC locations."
    },
    {
      question: "How do you maintain passenger safety during commutes?",
      answer: "We ensure safety through real-time GPS tracking, verified drivers, vehicle maintenance, and adherence to sanitization and health protocols."
    },
    {
      question: "Do corporate clients receive priority support?",
      answer: "Yes, all corporate clients are provided with a dedicated account manager and a priority helpline for faster issue resolution and personalized service."
    }
  ]
];

const testimonialsData = [
  {
    name: "Mr. Ajay Pawar",
    designation: "Admin Manager, Satara Engineering Group",
    rating: [1, 1, 1, 1, 1],
    text: "“We’ve seen a significant improvement in employee punctuality and morale since partnering with eTravo. Their drivers are always professional and reliable.”"
  },
  {
    name: "Ms. Manisha Jagtap",
    designation: "HR Executive, AgroTech Industries",
    rating: [1, 1, 1, 1, 1],
    text: "“eTravo’s flexible shift-based cab service has helped us streamline transportation for our production staff. Great service and consistent support.”"
  }
];































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Satara MIDC",
  "image": "https://www.etravo.in/images/keyword/cab-service-satara-midc.jpg",
  "description": "Reliable corporate cab service in Satara MIDC offering employee transport, business travel, industrial area cabs, and affordable AC corporate rentals with professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "4300"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1699",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/cab-service-satara-midc"
  }
};







    return (
        <div>
<Helmet>
  <title>Cab Service in Satara MIDC | Corporate & Industrial Cabs | eTravo</title>
  <meta 
    name="description" 
    content="Book reliable corporate cab service in Satara MIDC for staff commute, business meetings, and industrial transport. Affordable AC corporate cabs available at eTravo." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/77.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Cabserviceinsatara;